export default __webpack_public_path__ + "static/media/avatar_user.08223b40.webp";